/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramAuthControllerAuthorizeByCredentialsMutationRequest,
  TelegramAuthControllerAuthorizeByCredentialsMutationResponse,
  TelegramAuthControllerAuthorizeByCredentials401,
  TelegramAuthControllerAuthorizeByCredentials403,
} from '../../types/TelegramAuthControllerAuthorizeByCredentials.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { telegramAuthAuthorizeByCredentials } from '../../methods/telegramAuthAuthorizeByCredentials.ts';
import { useMutation } from '@tanstack/react-query';

export const telegramAuthAuthorizeByCredentialsMutationKey = () =>
  [{ url: '/api/telegram/auth/credentials/login' }] as const;

export type TelegramAuthAuthorizeByCredentialsMutationKey = ReturnType<
  typeof telegramAuthAuthorizeByCredentialsMutationKey
>;

/**
 * {@link /api/telegram/auth/credentials/login}
 */
export function useTelegramAuthAuthorizeByCredentials<TContext>(
  options: {
    mutation?: UseMutationOptions<
      TelegramAuthControllerAuthorizeByCredentialsMutationResponse,
      ResponseErrorConfig<
        TelegramAuthControllerAuthorizeByCredentials401 | TelegramAuthControllerAuthorizeByCredentials403
      >,
      { data: TelegramAuthControllerAuthorizeByCredentialsMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<TelegramAuthControllerAuthorizeByCredentialsMutationRequest>> & {
      client?: typeof fetch;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? telegramAuthAuthorizeByCredentialsMutationKey();

  return useMutation<
    TelegramAuthControllerAuthorizeByCredentialsMutationResponse,
    ResponseErrorConfig<
      TelegramAuthControllerAuthorizeByCredentials401 | TelegramAuthControllerAuthorizeByCredentials403
    >,
    { data: TelegramAuthControllerAuthorizeByCredentialsMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return telegramAuthAuthorizeByCredentials(data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
